/** @jsx jsx */

import { ReactNode } from 'react';

import { HeadingLevel } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

type Props = { children: ReactNode };

const Styles = {
  root: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-x: hidden;
  `,
};

const Wrapper = (props: Props) => (
  <HeadingLevel>
    <div css={Styles.root}>{props.children}</div>
  </HeadingLevel>
);

export default Wrapper;
